import { AxiosError } from 'axios'

export const getErrorDetails = (error: unknown) => {
  if (error instanceof AxiosError) {
    return {
      status: error.response?.status,
      data: error.response?.data as Record<string, unknown> | undefined,
      config: error.config,
      error: error instanceof Error ? error.message : String(error),
      stack: error instanceof Error ? error.stack : undefined,
    }
  }
  return {
    error: error instanceof Error ? error.message : String(error),
    stack: error instanceof Error ? error.stack : undefined,
  }
}
